import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleAdsBrandIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.63 15.16 9.24 3.71a3.35 3.35 0 0 1 5.8 3.35L8.43 18.51a3.35 3.35 0 1 1-5.8-3.35Z",
			fill: "#FBBC04"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.37 15.16 14.76 3.71a3.35 3.35 0 0 0-5.8 3.35l6.61 11.45a3.35 3.35 0 1 0 5.8-3.35Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.33,
			cy: 16.84,
			r: 3.35,
			fill: "#34A853"
		})
	]
});
export default SvgGoogleAdsBrandIcon;
